<template>
  <div class="d-cal"
       :id="'calendar_dom_id_' + calendarDOMUuid"
       :class="[
         {'d-cal--multi': isMultiCalendar},
         {'d-cal--am-pm': isLocaleEn},
         {'d-cal--loading': isLoadingEvents},
         {'d-cal--is-list-view': isShowAsList},
         {'d-cal--highlight-events': isCopyCalendarModalOpen}]">
    <div class="d-cal__events-loading" v-if="isLoadingEvents">
      <Loader bg-color="#fff"></Loader>
    </div>
    <DCalendarList
      v-if="isShowAsList"
      :calendarName="calendarName"
      :events="eventsWithMetaData"
      :date="date"
      :isShowWeekends="isShowWeekends"
      :firstDayOfWeek="firstDayOfWeek"
      :isCalendarInPrintMode="isCalendarInPrintMode">
    </DCalendarList>
    <DCalendarSubjects
      v-if="isEditable && calendarId && !isLocked"
      :calendar-id="calendarId"
      :dragActiveDate="dragActiveDate"
      :school="school"
      :locale="locale"
      :deleteSubject="deleteSubject"
      @movedXY="setMovedXY"
      @setDragLesson="setTheExternalEvent"
      @setIsDraggingExternalEvent="setIsDraggingExternalEvent"
      @doMouseUp="subjectsMouseUp"
      @onMouseEnter="onMouseEnterSubjects"
      @onMouseLeave="onMouseLeaveSubjects"
      @setActiveSubjectBCR="setTheExternalEventBCR">
    </DCalendarSubjects>
    <div class="d-cal__week" v-if="!isShowAsList">
      <div class="d-cal__header" v-if="!isHideHeader">
        <div class="d-cal__week__header__name" :class="{'d-cal__week__header__name--no-sidebar': !showSidebar}"
             v-if="isMultiCalendar">{{ calendarName }}
        </div>
        <ul class="d-cal__week__header">
          <li class="d-cal__week__header__day--weeknumber" v-if="showSidebar">
            <template v-if="!isHideDates">{{ i18n[locale].week }} {{
              theWeekNumber
              }}</template>
          </li>
          <li class="d-cal__week__header__day"
              :class="{'d-cal__week__header__day--today': day.isToday}"
              v-for="day in days">
            {{ isHideDates ? day.dayName : day.date }}
            <span v-if="day.isToday && !isCalendarInPrintMode">{{ $t('repitition.today') }}</span>
          </li>
        </ul>
      </div>
      <div class="d-cal__week__timed">
        <ul class="d-cal__week__timed__sidebar" v-if="showSidebar">
          <li class="time" v-for="(n, key) in hoursInLocale"><span v-if="key !== 0">{{ n }}</span></li>
        </ul>
        <div class="d-cal__week__timed__container">
          <ul class="d-cal__week__timed__background">
            <ul class="days-container">
              <li class="days-container__day" v-for="day in days">
                <DCalendarDayDraggable
                  v-if="isEditable"
                  :calendar="calendar"
                  :isLocked="isLocked"
                  :events="eventsWithMetaData"
                  :calendarId="calendarId"
                  :calStartTime="calStartTime"
                  :calEndTime="calEndTime"
                  :slotHeight="slotHeight"
                  :isEventsClickable="isEventsClickable"
                  :date="day.day"
                  :dragLesson="theDragLesson"
                  :dragEventY="dragEventY"
                  :dragActiveDate="dragActiveDate"
                  :dragActiveDates="dragActiveDates"
                  :dragEventEnd="dragEventEnd"
                  :dragEventStart="dragEventStart"
                  :dragEventHeight="dragEventHeight"
                  :isResizingEvent="isResizingEvent"
                  :isSideResizingEvent="isSideResizingEvent"
                  :isDraggingEvent="isDraggingEvent"
                  :isDraggingExternalEvent="isDraggingExternalEvent"
                  :theExternalEvent="theExternalEvent"
                  :isCopyCalendarModalOpen="isCopyCalendarModalOpen"
                  @setDragEventEnd="setDragEventEnd"
                  @setDragEventStart="setDragEventStart"
                  @setDragLesson="setTheDragLesson"
                  @setDragEventY="setDragEventY"
                  @setDragEventHeight="setDragEventHeight"
                  @setDragActiveDate="setDragActiveDate"
                  @setIsResizingEvent="setIsResizingEvent"
                  @setIsSideResizingEvent="setIsSideResizingEvent"
                  @setIsDraggingEvent="setIsDraggingEvent"
                  @onEventClick="onEventClick"
                  @onMouseUp="onMouseUpFromDragging"
                  @setIsDraggingExternalEvent="setIsDraggingExternalEvent"
                  @setTheDeleteSubjectCursorPlacement="setTheDeleteSubjectCursorPlacement">
                </DCalendarDayDraggable>
                <DCalendarDay
                  v-if="!isEditable"
                  :events="eventsWithMetaData"
                  :isCalendarInPrintMode="isCalendarInPrintMode"
                  :isCalNoBgColors="isCalNoBgColors"
                  :calendarId="calendarId"
                  :isMobile="isMobile"
                  :calStartTime="calStartTime"
                  :calEndTime="calEndTime"
                  :slotHeight="slotHeight"
                  :isEventsClickable="isEventsClickable"
                  :eventFontSize="eventFontSize"
                  :date="day.day"
                  :isHideCalendars="isHideCalendars"
                  :isHideDates="isHideDates"
                  @onPresenceClick="onPresenceClick"
                  @onEventClick="onEventClick">
                </DCalendarDay>
              </li>
            </ul>
            <li
              class="time-slot"
              v-for="n in hoursInLocale.length * 2"
              :key="n"></li>
          </ul>
        </div>
      </div>
    </div>
    <DCalendarDraggedSubject
      v-if="movedY && (theExternalEvent || deleteSubject) && !dragActiveDate"
      :movedY="movedY"
      :movedX="movedX"
      :deleteSubject="deleteSubject"
      :activeSubject="theExternalEvent"
      :activeSubjectBCR="theExternalEventBCR">
    </DCalendarDraggedSubject>
    <ModalConfirmation
      v-if="isConfirmDeleteModal"
      :show-close="false"
      :appendToBody="false"
      :isShowDontAskAgain="true"
      class="d-modal--from-top"
      @close="closeIsConfirmDelete"
      @confirm="onConfirmDeleteEvent">
    </ModalConfirmation>
  </div>
</template>

<script>
import Loader from '../common/Loader'
import moment from 'moment'
import DCalendarDay from './DCalendarDay'
import DCalendarDayDraggable from './DCalendarDayDraggable'
import DCalendarSubjects from './DCalendarSubjects'
import DCalendarDraggedSubject from './DCalendarDraggedSubject'
import DCalendarList from './DCalendarList'
import ModalConfirmation from '../Modals/ModalConfirmation'

export default {
  components: {
    DCalendarList,
    DCalendarDraggedSubject,
    DCalendarSubjects,
    DCalendarDay,
    Loader,
    DCalendarDayDraggable,
    ModalConfirmation
  },
  props: {
    calendar: {
      type: Object,
      default: null
    },
    calendarId: {
      default: 7
    },
    calendarName: {
      default: ''
    },
    date: {
      default: () => moment()
    },
    isMultiCalendar: {
      type: Boolean,
      default: false
    },
    showSidebar: {
      type: Boolean,
      default: true
    },
    isShowWeek: {
      type: Boolean,
      default: true
    },
    isShowWeekends: {
      type: Boolean,
      default: false
    },
    firstDayOfWeek: {
      type: Number,
      default: 1
    },
    startTime: {
      default: '06:00:00'
    },
    endTime: {
      default: '16:00:00'
    },
    events: {
      type: Array,
      default: () => []
    },
    isLoadingEvents: {
      type: Boolean,
      default: false
    },
    isEventsClickable: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isLocked: {
      type: Boolean,
      default: false
    },
    isCalendarInPrintMode: {
      type: Boolean,
      default: false
    },
    isShowStudents: {
      type: Boolean,
      default: false
    },
    isShowAsList: {
      type: Boolean,
      default: false
    },
    isHideHeader: {
      type: Boolean,
      default: false
    },
    initNumberOfDays: {
      default: null
    },
    isCalNoBgColors: {
      type: Boolean,
      default: false
    },
    eventFontSize: {
      default: 10
    },
    isAbsenceEditable: {
      type: Boolean,
      default: true
    },
    isHideCalendars: {
      type: Boolean,
      default: false
    },
    isHideDates: {
      type: Boolean,
      default: false
    },
    isCopyCalendarModalOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      slotHeight: 40,
      slotWidth: 50,
      i18n: {
        da: {
          week: 'Uge'
        },
        nb: {
          week: 'Uke'
        },
        en: {
          week: 'W '
        }
      },
      activeEvent: null,
      theDragLesson: null,
      movedX: 0,
      movedY: 0,
      dragEventY: 0,
      dragEventHeight: 0,
      dragActiveDate: null,
      dragActiveDates: [],
      dragEventStart: moment(),
      dragEventEnd: moment(),
      isResizingEvent: false,
      isSideResizingEvent: false,
      isDraggingEvent: false,
      isDraggingExternalEvent: false,
      theExternalEvent: null,
      theExternalEventBCR: null,
      isWindowResizingTimer: null,
      deleteSubject: null,
      theDeleteEvent: null,
      isDeleteSubjectOverSubjects: false,
      isConfirmDeleteModal: false,
      calendarDOMUuid: this.generateUUID()
    }
  },
  computed: {
    school () {
      return this.$store.state.activeSchool
    },
    locale () {
      return this.$store.getters.locale
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    userSchools () {
      return this.$store.getters.userSchools
    },
    eventsWithMetaData () {
      return this.events.map(lesson => {
        // Clone lesson object if necessary to avoid direct mutations
        let dLesson = {...lesson}

        // Short-circuit if `rendering` is true by setting default values
        if (lesson.rendering) {
          return {
            ...lesson,
            event_starttime: '',
            event_endtime: '',
            event_key: this.generateUUID(),
            has_notes: false,
            has_substitute: false,
            group: '',
            teacher: '',
            v_teachers_arr: [],
            room: '',
            substitutes: '',
            eventDuration: 0,
            v_other_school: false,
            v_is_editable: false,
            v_sort_key: ''
          }
        }

        // Helper to get the class name with the highest minutes where calendar_type is "klass"
        const getHighestMinutesClassName = (calendars) => {
          const highestMinutesCalendar = calendars.reduce((highest, calendar) => {
            if (calendar.calendar_type === 'klass' && (!highest || calendar.minutes > highest.minutes)) {
              return calendar
            }
            return highest
          }, null)

          // Return the name if a "klass" calendar was found, otherwise an empty string
          return highestMinutesCalendar ? highestMinutesCalendar.name : ''
        }

        // Helper to clean HTML from text fields
        const cleanText = (content) => (content ? content.replace(/<(?:.|\n)*?>/gm, '') : '')

        // Clean notes-related fields
        const teacherNotes = cleanText(dLesson.teacher_notes)
        const hasNotes = teacherNotes || cleanText(dLesson.description) || cleanText(dLesson.notes_for_students) || cleanText(dLesson.learning_goal)

        let groups = []
        let rooms = []
        let teachers = []
        let students = []
        let substitutes = []
        let hasSubstitutes = false
        let eventActiveCalendarDuration = 0

        eventActiveCalendarDuration = 0
        dLesson.calendars.forEach(calendar => {
          if (calendar.calendar_id === this.calendarId) {
            eventActiveCalendarDuration = calendar.minutes
          }

          const name = calendar.name
          switch (calendar.calendar_type) {
            case 'klass':
              if (calendar.calendar_id !== this.calendarId) groups.push(name)
              break
            case 'room':
              if (calendar.calendar_id !== this.calendarId) rooms.push(name)
              break
            case 'user':
              if (calendar.substitute) {
                hasSubstitutes = true
                substitutes.push(name)
              } else if (calendar.calendar_id !== this.calendarId) {
                teachers.push(name)
              }
              break
            case 'student':
              if (calendar.calendar_id !== this.calendarId) students.push(name)
              break
          }
        })

        // Get the class name with the highest minutes for "klass" type
        const className = getHighestMinutesClassName(dLesson.calendars)

        // Prepare properties to be set in one go
        const updatedLesson = {
          ...lesson,
          event_starttime: moment(dLesson.start).locale(this.locale).format('LT'),
          event_endtime: moment(dLesson.end).locale(this.locale).format('LT'),
          event_key: `${this.calendarId}_${dLesson.event_id}`,
          has_notes: !!hasNotes,
          has_substitute: hasSubstitutes,
          group: groups.join(', '),
          teacher: teachers.join(', '),
          room: rooms.join(', '),
          substitutes: substitutes.join(', '),
          eventDuration: eventActiveCalendarDuration,
          v_other_school: this.getIsEventOtherSchool(lesson),
          v_is_editable: this.getIsEventEditable(lesson),
          v_sort_key: className,
          v_other_calendar: this.calendarId * 1 !== lesson.calendar_id && (this.allCalendarsInHash[lesson.calendar_id] || true)
        }

        // Conditionally add students if required
        if (this.isShowStudents) {
          updatedLesson.students = students.join(', ')
        }

        return updatedLesson
      })
    },
    isLocaleEn () {
      return this.locale === 'en'
    },
    calStartHour () {
      return this.startTime.slice(0, 2) !== '00' ? this.startTime.slice(0, 2) : '01'
    },
    calEndHour () {
      return this.endTime.slice(0, 2)
    },
    calStartTime () {
      return moment().set({hour: this.calStartHour, minutes: 0, seconds: 0})
    },
    calEndTime () {
      return moment().set({hour: this.calEndHour, minutes: 0, seconds: 0})
    },
    theWeekNumber () {
      return moment(this.date).isoWeek()
    },
    numberOfDays () {
      if (this.initNumberOfDays) {
        return this.initNumberOfDays
      }
      if (this.isShowWeek) {
        if (this.isShowWeekends) {
          return this.firstDayOfWeek + 6
        } else {
          return this.firstDayOfWeek + 4
        }
      } else {
        return 1
      }
    },
    days () {
      let correctDates = []
      let days = []
      if (this.isShowWeek) {
        for (let i = this.firstDayOfWeek; i <= this.numberOfDays; i++) {
          const date = moment(this.date).isoWeekday(i)
          const dateObj = {
            day: date,
            date: this.getShowDate(date),
            isToday: moment().format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD'),
            dayName: date.format('dddd')
          }
          correctDates.push(dateObj)
          days.push(date)
        }
      } else {
        const date = moment(this.date)
        const dateObj = {
          day: date,
          date: this.getShowDate(date),
          isToday: moment().format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD')
        }
        correctDates.push(dateObj)
        days.push(date)
      }
      this.$emit('dates', days)
      return correctDates
    },
    hours () {
      let hours = []
      let diffInHours = (this.calEndHour * 1) - (this.calStartHour * 1)
      for (let i = 0; i <= diffInHours; i++) {
        hours.push(moment(this.calStartTime).add(i, 'hours'))
      }
      return hours
    },
    hoursInLocale () {
      let localeHours = []
      this.hours.forEach(h => {
        localeHours.push(moment(h).locale(this.locale).format('LT'))
      })
      return localeHours
    },
    isMobile () {
      return this.$store.state.isDeviceMobile
    }
  },
  watch: {
    isCalendarInPrintMode () {
      return this.getSlotHeight()
    },
    startTime () {
      this.getSlotHeight()
    },
    endTime () {
      this.getSlotHeight()
    }
  },
  methods: {
    onMouseUpFromDragging () {
      if (this.deleteSubject && this.isDeleteSubjectOverSubjects) {
        this.theDeleteEvent = this.deleteSubject
        const isDontAskDeleteEvent = this.$helpers.getLocalStorage('do_dont_ask_delete_event')
        if (isDontAskDeleteEvent) {
          this.deleteEvent()
        } else {
          setTimeout(_ => {
            this.isConfirmDeleteModal = true
          }, 0)
        }
      }
    },
    closeIsConfirmDelete () {
      this.isConfirmDeleteModal = false
      this.theDeleteEvent = null
    },
    onConfirmDeleteEvent (evt) {
      this.isConfirmDeleteModal = false
      if (evt) {
        this.$helpers.setLocalStorage('do_dont_ask_delete_event', true)
      }
      this.deleteEvent()
    },
    deleteEvent () {
      this.$store.dispatch('deleteEvent', this.theDeleteEvent)
      this.theDeleteEvent = null
    },
    onMouseEnterSubjects () {
      if (this.deleteSubject) {
        this.isDeleteSubjectOverSubjects = true
      }
    },
    onMouseLeaveSubjects () {
      this.isDeleteSubjectOverSubjects = false
    },
    generateUUID () {
      let d = new Date().getTime()
      let d2 = (window.performance && window.performance.now && (window.performance.now() * 1000)) || 0
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = Math.random() * 16
        if (d > 0) {
          r = (d + r) % 16 | 0
          d = Math.floor(d / 16)
        } else {
          r = (d2 + r) % 16 | 0
          d2 = Math.floor(d2 / 16)
        }
        return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16)
      })
    },
    getIsEventEditable (event) {
      if (event.event_type === 'absence') {
        return this.isAbsenceEditable
      }
      return (this.calendarId * 1) === event.calendar_id && event.event_type !== 'presence'
    },
    getIsEventOtherSchool (event) {
      return event.event_type !== 'presence' && !this.userSchools[event.school_id]
    },
    setTheExternalEventBCR (BCR) {
      this.theExternalEventBCR = BCR
    },
    setMovedXY (x, y) {
      this.movedX = x
      this.movedY = y
    },
    subjectsMouseUp () {
      this.theExternalEvent = null
    },
    setIsDraggingExternalEvent (boolean) {
      this.isDraggingExternalEvent = boolean
      this.$emit('onDragging', boolean)
    },
    setTheExternalEvent (subject) {
      if (subject) {
        this.$emit('onDragging', true)
        this.theExternalEvent = subject
        this.isDraggingExternalEvent = true
        this.setDragActiveDate(null)
      } else {
        this.$emit('onDragging', false)
        this.theDragLesson = null
        this.setIsDraggingEvent(false)
      }
    },
    setIsDraggingEvent (boolean) {
      this.$emit('onDragging', boolean)
      this.isDraggingEvent = boolean
      if (!boolean) {
        this.$store.dispatch('clearAvailability')
        this.deleteSubject = null
        this.isDeleteSubjectOverSubjects = false
        this.setMovedXY(null, null)
        return
      }
      if (this.theDragLesson && !this.theExternalEvent) {
        const lessonObj = {
          calendarId: this.theDragLesson.obj.calendar_id,
          eventId: this.theDragLesson.obj.event_id
        }
        this.$store.dispatch('readEventAvailability', lessonObj)
        if (!this.isResizingEvent && !this.isSideResizingEvent) {
          this.deleteSubject = this.theDragLesson.obj
        }
      }
    },
    setTheDeleteSubjectCursorPlacement (obj) {
      if (this.deleteSubject) {
        this.setMovedXY(obj.x, obj.y)
      }
    },
    setDragEventStart (mom) {
      this.dragEventStart = mom
    },
    setDragEventEnd (mom) {
      this.dragEventEnd = mom
    },
    setDragActiveDate (mom) {
      this.dragActiveDate = mom
      if (!this.isSideResizingEvent) {
        return
      }
      if (mom === null) {
        this.dragActiveDates = []
        return
      }
      const theDragLessonStartDate = moment(this.theDragLesson.obj.start).format('YYYY-MM-DD')
      const date = moment(mom).format('YYYY-MM-DD')
      const idx = this.dragActiveDates.indexOf(date)
      if (theDragLessonStartDate !== date && idx < 0) {
        this.dragActiveDates.push(date)
      } else {
        this.dragActiveDates.splice(idx + 1, this.dragActiveDates.length)
      }
    },
    setDragEventY (px) {
      this.dragEventY = px
    },
    setDragEventHeight (px) {
      this.dragEventHeight = px
    },
    setIsResizingEvent (boolean) {
      this.isResizingEvent = boolean
    },
    setIsSideResizingEvent (boolean) {
      this.isSideResizingEvent = boolean
    },
    setTheDragLesson (lesson) {
      this.theDragLesson = lesson
    },
    onEventClick (event) {
      this.$emit('onEventClick', event)
    },
    onPresenceClick (event) {
      this.$emit('onPresenceClick', event)
    },
    getShowDate (date) {
      return this.locale !== 'en' ? moment(date).locale(this.locale).format('ddd[.] DD/MM') : moment(date).locale(this.locale).format('ddd MM/DD')
    },
    getSlotHeight () {
      if (this.isShowAsList) {
        return
      }
      this.$nextTick(_ => {
        this.slotHeight = document.querySelector('#calendar_dom_id_' + this.calendarDOMUuid + ' .time-slot').getBoundingClientRect().height
        this.slotWidth = document.querySelector('#calendar_dom_id_' + this.calendarDOMUuid + ' .day-cal__event-container').getBoundingClientRect().width
      })
    },
    handleWindowResize () {
      clearTimeout(this.isWindowResizingTimer)
      this.isWindowResizingTimer = setTimeout(_ => {
        this.getSlotHeight()
      }, 0)
    }
  },
  mounted () {
    this.$nextTick(_ => {
      this.getSlotHeight()
      window.addEventListener('resize', this.handleWindowResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

:root {
  --borderColor: #d9d9d9;
  --fontColor: #333;
  --fontColorGrey: #8e8e93;
  --timestampWidth: 48px;
  --timestampWidthEn: 56px;
}

.d-cal ul {
  margin: 0;
}

.d-cal {
  position: absolute;
  height: 100%;
  width: 100%;
  border: 1px solid var(--borderColor);
  display: flex;
  align-items: stretch;
  user-select: text;
}

.d-cal.d-cal--is-list-view {
  position: relative;
}

.d-cal__events-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(255 255 255 / 40%);
  z-index: 12;
  padding-top: 50px;
}

.d-cal__week {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  z-index: 1;
}

.d-cal__sidebar {
  border-right: 1px solid var(--borderColor);
}

.d-cal__header {
  display: flex;
  flex-direction: column;
}

.d-cal__week__header__name {
  text-align: center;
  border-bottom: 1px solid var(--borderColor);
  font-weight: bold;
}

.d-cal__week__header__name.d-cal__week__header__name--no-sidebar {
  padding-left: 0;
}

.d-cal__week__header {
  display: flex;
  flex-direction: row;
  height: 24px;
  min-height: 24px;
  line-height: 24px;
  border-bottom: 1px solid var(--borderColor);
}

.d-cal__week__header__day {
  flex: 1;
  font-size: 11px;
  color: var(--fontColor);
  text-align: center;
  overflow: hidden;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: center;
}

.d-cal__week__header__day--today span {
  background-color: #6772e5;
  padding: 0 3px;
  border-radius: 4px;
  font-weight: bold;
  color: #ffffff;
  font-size: 8px;
  font-weight: lighter;
  text-transform: none;
  height: 12px;
  line-height: 12px;
  margin-left: 4px;
}

.d-cal__week__header__day--weeknumber {
  width: var(--timestampWidth);
  font-size: 11px;
  text-align: center;
  color: var(--fontColorGrey);
  flex: none !important;
}

.d-cal__week__timed {
  margin-right: 1px;
  display: flex;
  flex-direction: row;
  flex: 1;
}

.d-cal__week__timed__sidebar {
  display: flex;
  flex-direction: column;
  width: var(--timestampWidth);
}

.d-cal--am-pm .d-cal__week__header__day--weeknumber,
.d-cal--am-pm .d-cal__week__timed__sidebar {
  width: var(--timestampWidthEn);
}

.d-cal__week__timed__sidebar .time {
  flex: 1;
  padding-right: 8px;
  font-size: 11px;
  text-align: right;
  margin-top: -10px;
  color: var(--fontColorGrey);
  user-select: none;
}

.d-cal--am-pm .d-cal__week__timed__sidebar .time {
  padding-right: 4px;
}

.d-cal__week__timed__background {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
}

.d-cal__week__timed__container {
  position: relative;
  flex: 1;
  display: flex;
}

.days-container {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.days-container__day {
  position: relative;
  flex: 1;
  border: 0 solid #d9d9d9;
  border-left-width: 1px;
  overflow: hidden;
}

.time-slot {
  flex: 1;
  border: 1px solid rgba(217, 217, 217, 0.7);
  border-width: 0 0 1px;
  z-index: 1;
  width: 100%;
}

.time-slot:last-child {
  border-width: 0;
}

.time-slot:nth-child(2n) {
  border-bottom-style: dotted;
}

</style>



// WEBPACK FOOTER //
// DCalendar.vue?40c1f7e6